var map = {
	"./annotation/annotation_celltypist.js": [
		"./src/schema/UI-schema/Tools/annotation/annotation_celltypist.js",
		"src_schema_UI-schema_Tools_annotation_annotation_celltypist_js"
	],
	"./annotation/annotation_scanvi.js": [
		"./src/schema/UI-schema/Tools/annotation/annotation_scanvi.js",
		"src_schema_UI-schema_Tools_annotation_annotation_scanvi_js"
	],
	"./annotation/annotation_singler.js": [
		"./src/schema/UI-schema/Tools/annotation/annotation_singler.js",
		"src_schema_UI-schema_Tools_annotation_annotation_singler_js"
	],
	"./evaluation/evaluation_cidr.js": [
		"./src/schema/UI-schema/Tools/evaluation/evaluation_cidr.js",
		"src_schema_UI-schema_Tools_evaluation_evaluation_cidr_js"
	],
	"./evaluation/evaluation_seurat.js": [
		"./src/schema/UI-schema/Tools/evaluation/evaluation_seurat.js",
		"src_schema_UI-schema_Tools_evaluation_evaluation_seurat_js"
	],
	"./formatting/formatting_convert.js": [
		"./src/schema/UI-schema/Tools/formatting/formatting_convert.js",
		"src_schema_UI-schema_Tools_formatting_formatting_convert_js"
	],
	"./imputation/imputation_magic.js": [
		"./src/schema/UI-schema/Tools/imputation/imputation_magic.js",
		"src_schema_UI-schema_Tools_imputation_imputation_magic_js"
	],
	"./imputation/imputation_saver.js": [
		"./src/schema/UI-schema/Tools/imputation/imputation_saver.js",
		"src_schema_UI-schema_Tools_imputation_imputation_saver_js"
	],
	"./imputation/imputation_scgnn.js": [
		"./src/schema/UI-schema/Tools/imputation/imputation_scgnn.js",
		"src_schema_UI-schema_Tools_imputation_imputation_scgnn_js"
	],
	"./integration/integration_harmony.js": [
		"./src/schema/UI-schema/Tools/integration/integration_harmony.js",
		"src_schema_UI-schema_Tools_integration_integration_harmony_js"
	],
	"./integration/integration_liger.js": [
		"./src/schema/UI-schema/Tools/integration/integration_liger.js",
		"src_schema_UI-schema_Tools_integration_integration_liger_js"
	],
	"./integration/integration_scvi.js": [
		"./src/schema/UI-schema/Tools/integration/integration_scvi.js",
		"src_schema_UI-schema_Tools_integration_integration_scvi_js"
	],
	"./integration/integration_seurat.js": [
		"./src/schema/UI-schema/Tools/integration/integration_seurat.js",
		"src_schema_UI-schema_Tools_integration_integration_seurat_js"
	],
	"./normalization/normalization_deseq2.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_deseq2.js",
		"src_schema_UI-schema_Tools_normalization_normalization_deseq2_js"
	],
	"./normalization/normalization_fpkm.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_fpkm.js",
		"src_schema_UI-schema_Tools_normalization_normalization_fpkm_js"
	],
	"./normalization/normalization_logcp10k.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_logcp10k.js",
		"src_schema_UI-schema_Tools_normalization_normalization_logcp10k_js"
	],
	"./normalization/normalization_logcpm.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_logcpm.js",
		"src_schema_UI-schema_Tools_normalization_normalization_logcpm_js"
	],
	"./normalization/normalization_pearson_residuals.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_pearson_residuals.js",
		"src_schema_UI-schema_Tools_normalization_normalization_pearson_residuals_js"
	],
	"./normalization/normalization_rle.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_rle.js",
		"src_schema_UI-schema_Tools_normalization_normalization_rle_js"
	],
	"./normalization/normalization_scran.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_scran.js",
		"src_schema_UI-schema_Tools_normalization_normalization_scran_js"
	],
	"./normalization/normalization_sctransform.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_sctransform.js",
		"src_schema_UI-schema_Tools_normalization_normalization_sctransform_js"
	],
	"./normalization/normalization_tmm.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_tmm.js",
		"src_schema_UI-schema_Tools_normalization_normalization_tmm_js"
	],
	"./normalization/normalization_tpm.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_tpm.js",
		"src_schema_UI-schema_Tools_normalization_normalization_tpm_js"
	],
	"./normalization/normalization_upperquartile.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_upperquartile.js",
		"src_schema_UI-schema_Tools_normalization_normalization_upperquartile_js"
	],
	"./normalization/normalization_uq.js": [
		"./src/schema/UI-schema/Tools/normalization/normalization_uq.js",
		"src_schema_UI-schema_Tools_normalization_normalization_uq_js"
	],
	"./quality_control/quality_control_bioconductor.js": [
		"./src/schema/UI-schema/Tools/quality_control/quality_control_bioconductor.js",
		"src_schema_UI-schema_Tools_quality_control_quality_control_bioconductor_js"
	],
	"./quality_control/quality_control_dropkick.js": [
		"./src/schema/UI-schema/Tools/quality_control/quality_control_dropkick.js",
		"src_schema_UI-schema_Tools_quality_control_quality_control_dropkick_js"
	],
	"./quality_control/quality_control_scanpy.js": [
		"./src/schema/UI-schema/Tools/quality_control/quality_control_scanpy.js",
		"src_schema_UI-schema_Tools_quality_control_quality_control_scanpy_js"
	],
	"./quality_control/quality_control_seurat.js": [
		"./src/schema/UI-schema/Tools/quality_control/quality_control_seurat.js",
		"src_schema_UI-schema_Tools_quality_control_quality_control_seurat_js"
	],
	"./visualization/visualization_t-sne.js": [
		"./src/schema/UI-schema/Tools/visualization/visualization_t-sne.js",
		"src_schema_UI-schema_Tools_visualization_visualization_t-sne_js"
	],
	"./visualization/visualization_umap.js": [
		"./src/schema/UI-schema/Tools/visualization/visualization_umap.js",
		"src_schema_UI-schema_Tools_visualization_visualization_umap_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/schema/UI-schema/Tools lazy recursive ^\\.\\/.*\\/.*\\.js$ referencedExports: uiSchema, uiSchema, uiSchema";
module.exports = webpackAsyncContext;